import { Box, CssBaseline, Toolbar } from '@mui/material';
import { Outlet } from 'react-router-dom';
import AppBar from '../components/layout/AppBar';
import Drawer from '../components/layout/Drawer';
import { useState } from 'react';

const DRAWER_WIDTH = 240;

export default function MainLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [desktopOpen, setDesktopOpen] = useState(true);
  const [isClosing, setIsClosing] = useState(false);

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDesktopDrawerToggle = () => {
    setDesktopOpen(!desktopOpen);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar 
        drawerWidth={DRAWER_WIDTH}
        desktopOpen={desktopOpen}
        handleDrawerToggle={handleDrawerToggle}
        handleDesktopDrawerToggle={handleDesktopDrawerToggle}
      />
      <Drawer 
        drawerWidth={DRAWER_WIDTH}
        mobileOpen={mobileOpen}
        desktopOpen={desktopOpen}
        handleDrawerClose={handleDrawerClose}
        handleDesktopDrawerToggle={handleDesktopDrawerToggle}
        handleDrawerTransitionEnd={handleDrawerTransitionEnd}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { xs: '100%', sm: desktopOpen ? `calc(100% - ${DRAWER_WIDTH}px)` : '100%' },
          ml: { xs: 0, sm: desktopOpen ? 0 : 0 },
          transition: 'width 0.3s ease, margin 0.3s ease',
        }}
      >
        <Toolbar /> {/* This Toolbar ensures content is below the AppBar */}
        <Box sx={{ mt: 2 }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}

export { DRAWER_WIDTH };
